import React from 'react'
import truck from 'assets/svg/donut-truck.svg'
import LazyImage from 'app/theme/LazyImage'

export default function StartFoodTruck(props) {
  return (
    <a
      href="/marketplace/"
      className={[
        'bg-green text-white text-center p-5',
        props.className
      ]}
    >
      <h2 className="text-white font-platform text-5xl mb-5" style={{ lineHeight: '.85' }}>
        Start a Food Truck
      </h2>
      <div>
        <LazyImage
          src={truck}
          alt="Food Truck"
          className="m-auto"
          style={{
            maxWidth: 160
          }}
        />
      </div>
      <p className="font-light leading-tight text-xl mt-5">
        Get your food truck business rolling today.
      </p>
    </a>
  )
}
